<script setup lang="ts">
import { bemBuilder } from "@chatfood/core-utils";
import PagesMenu from "../menu.vue";
import type { PagesMenusProps } from "./props";
import { MenuSelector } from "~/components/menu-selector";
import { useOutletStore } from "~/stores/outlet";
import { useMenusStore } from "~/stores/menus";

const css = bemBuilder("pages-menus");

const props = defineProps<PagesMenusProps>();

const outlet = useOutletStore();
const menusStore = useMenusStore();
</script>

<template>
  <div :class="css()">
    <PagesMenu
      v-if="menusStore.hasOneMenu"
      :ordering-mode="props.orderingMode"
      :outlet-slug="props.outletSlug"
      :menu-slug="menusStore.firstMenu.slug"
    />
    <MenuSelector
      v-else
      :outlet-id="outlet.id"
      :ordering-mode="props.orderingMode"
    />
  </div>
</template>

<style lang="scss" scoped>
.pages-menus {
  position: relative;
}
</style>
